module.exports = __webpack_public_path__ + "static/media/3.05e0723b.png";